export default __webpack_public_path__ + "media/images/awesome-long-arrow-alt-right-b5231700eac8e2be027bef4c608382f1.svg";